// @ts-nocheck
/**
 * ツインキーシステム - 固有スキル定義
 *
 * 高ティア（S/A/B）カードに個別設定される固有スキル
 * 仕様書: twin_key_generic_skills_passives_v1.md
 *
 * 固有スキル持ちカードはスキル決定の最優先順位を持つ
 * 優先順位: 固有 → 役割 → 属性
 */

import { SKILL_EFFECT_TYPES, BUFF_TYPES, STATUS_TYPES } from './attributeSkills';

// ========================================
// 固有スキル定義
// カードID → スキル配列のマップ
// ========================================

/**
 * 固有スキルマップ
 * キー: カードID
 * 値: スキル配列（最大3つ）
 *
 * 将来的にTier S/A/Bカードに個別スキルを設定
 */
export const UNIQUE_SKILLS = {
  // ========================================
  // サンプル: 固有スキル持ちカード
  // ========================================

  // 例: C0000001 - 炎竜フレアドラゴン（Tier S想定）
  // C0000001: [
  //   {
  //     id: 'unique_C0000001_1',
  //     name: 'フレアブレス',
  //     description: '敵全体に攻撃×1.5ダメージ、火傷×2付与',
  //     skillSlot: 1,
  //     unlockLevel: 20,
  //     cooldown: 2,
  //     effects: [
  //       { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 1.5 },
  //       { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.BURN, stacks: 2, chance: 1.0, target: 'all_enemies' },
  //     ],
  //   },
  //   {
  //     id: 'unique_C0000001_2',
  //     name: '炎帝の威圧',
  //     description: '敵全体の攻撃↓×2、防御↓×1付与',
  //     skillSlot: 2,
  //     unlockLevel: 40,
  //     cooldown: 4,
  //     effects: [
  //       { type: SKILL_EFFECT_TYPES.DEBUFF_ALL, debuff: BUFF_TYPES.ATK_DOWN, stacks: 2 },
  //       { type: SKILL_EFFECT_TYPES.DEBUFF_ALL, debuff: BUFF_TYPES.DEF_DOWN, stacks: 1 },
  //     ],
  //   },
  //   {
  //     id: 'unique_C0000001_3',
  //     name: '業火滅龍',
  //     description: '敵全体に攻撃×2.5ダメージ、火傷状態の敵には追加で50%ダメージ',
  //     skillSlot: 3,
  //     unlockLevel: 60,
  //     cooldown: 6,
  //     initialCooldown: 3,
  //     effects: [
  //       { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 2.5, statusBonus: { [STATUS_TYPES.BURN]: 1.5 } },
  //     ],
  //   },
  // ],
};

// ========================================
// ヘルパー関数
// ========================================

/**
 * カードが固有スキルを持つか確認
 * @param {string} cardId - カードID
 * @returns {boolean} 固有スキルを持つ場合true
 */
export const hasUniqueSkills = (cardId) => {
  return cardId in UNIQUE_SKILLS && UNIQUE_SKILLS[cardId].length > 0;
};

/**
 * カードの固有スキルを取得
 * @param {string} cardId - カードID
 * @returns {Object[]|null} スキル配列、なければnull
 */
export const getUniqueSkills = (cardId) => {
  if (!hasUniqueSkills(cardId)) return null;
  return UNIQUE_SKILLS[cardId];
};

/**
 * 固有スキルを登録
 * 動的にスキルを追加する場合に使用
 * @param {string} cardId - カードID
 * @param {Object[]} skills - スキル配列
 */
export const registerUniqueSkills = (cardId, skills) => {
  UNIQUE_SKILLS[cardId] = skills;
};

/**
 * 固有スキルを削除
 * @param {string} cardId - カードID
 */
export const unregisterUniqueSkills = (cardId) => {
  delete UNIQUE_SKILLS[cardId];
};

/**
 * 登録済み固有スキルのカードID一覧を取得
 * @returns {string[]} カードID配列
 */
export const getUniqueSkillCardIds = () => {
  return Object.keys(UNIQUE_SKILLS).filter(id => UNIQUE_SKILLS[id].length > 0);
};

export default {
  UNIQUE_SKILLS,
  hasUniqueSkills,
  getUniqueSkills,
  registerUniqueSkills,
  unregisterUniqueSkills,
  getUniqueSkillCardIds,
};
